const LS_TOKEN = "braytron_space_token";
const LS_ID = "braytron_space_user_id";
const LS_UUID = "braytron_space_user_uuid";

export { LS_TOKEN, LS_ID, LS_UUID };
